import React, { FC, useState } from 'react'
//* utils

//* styles

//* utils
import { WrapperImage as WrapperImageModel } from '../../../models/others/image'
import { MicrocopySet } from '../../../models/others/microcopy'

//* components
import ImgUtil from '../../../utils/img.utils'
import LeadershipModal from '../../page/resources/company/leadershipModal'
import Button from '../button'
import WrapperImage from '../wrapperImage'

type Props = {
  headshot: WrapperImageModel | null
  miniBio: any
  firstName: string
  lastName: string
  role: string
  company: string
  twitterProfile: string
  linkedInProfile: string
  microcopy: MicrocopySet | null
  bioIntro: string
  bioModal: boolean
  topicItemListUseCase: string
  useCase: string
}

const SpeakerBio: FC<Props> = ({
  headshot,
  miniBio,
  firstName,
  lastName,
  role,
  company,
  twitterProfile,
  linkedInProfile,
  bioIntro,
  bioModal,
  topicItemListUseCase,
  useCase,
}) => {
  const fullName = `${firstName} ${lastName}`
  const image = {
    url: headshot?.image?.file?.url || '',
    alt: headshot?.image.altText || 'headshot',
  }

  const [modalOpen, setModalOpen] = useState(false)
  const [modalData, setModalData] = useState({})

  const openModal = () => {
    if (!miniBio) return null

    setModalData({
      fullName,
      role,
      miniBio,
      twitterProfile,
      linkedInProfile,
      image: image?.url || null,
      topicItemListUseCase,
      useCase,
    })

    setModalOpen(true)
  }

  const closeModal = () => {
    setModalOpen(false)
  }

  return (
    <>
      <div className="Speaker">
        {image.url && (
          <div className="Speaker__Headshot">
            <WrapperImage
              className="Speaker__Headshot-Image"
              src={ImgUtil.getResizedImageUrl(image.url, 'width=430')}
              alt={image.alt}
            />
          </div>
        )}
        <div className="Speaker__Detail">
          {firstName && <div className="Speaker__Name">{fullName}</div>}
          {role && <div className="Speaker__Designation">{role}</div>}
          {company && <div className="Speaker__Company">{company}</div>}
          {bioModal && (
            <>
              <div onClick={openModal} className="Speaker__Bio">
                <Button
                  icon={true}
                  href={''}
                  text={bioIntro}
                  type={'inline-text-link'}
                  size={'small'}
                  theme={'light'}
                />
              </div>
            </>
          )}
        </div>
      </div>
      <LeadershipModal onClose={closeModal} open={modalOpen} data={modalData} />
    </>
  )
}

export default SpeakerBio
